export const indefiniteArticle = (string)=>/^[aeiou]/i.test(string) ? "an" : "a";
